import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { translate } from '../../modules/helper-functions'
import { colors } from '../../search-common/settings'

const Outer = styled.div`
  height: 100%;
  position: relative;
  margin: 0 auto;
  max-width: 1440px;
  width: 100%;
  padding: 20px;
  max-height: 120px;
  margin-bottom: 15px;

  &.expanded {
    max-height: inherit;
    margin-bottom: 0;
  }

  &:before {
    content: "";
    position:absolute;
    max-height: auto;
    background-image: linear-gradient(to bottom, rgba(0,0,0,0) 0%, ${colors.grayTone1}ee 90%, ${colors.grayTone1}ff 100%);
    width: 100%;
    top:0;
    bottom:0;
    left:0;
    display: relative;
    background-size: cover;
  }

  &.expanded :before {
    background-image: none;
    display: none;
  }
`

const Expand = styled.a`
  position: absolute;
  bottom: -15px;
  cursor: pointer;

  .expanded & {
    display: none;
  }
`
const Container = styled.div`
  max-height: 100px;
  overflow: hidden;
  .expanded & {
    max-height: 100%;
  }
`
/**
 * SEOContent component.
 */
class SEOContent extends React.Component {
  /**
   * Class constructor.
   *
   * @param {object} props
   */
  constructor( props ) {
    super( props )
    this.state = {
      expanded: false,
    }
    this.toggleExpanded = this.toggleExpanded.bind( this )
  }

  /**
   * Set expand state.
   */
  toggleExpanded() {
    this.setState({ expanded: !this.state.expanded })
  }

  /**
   * Gets the SEO content for the current
   * search or false if there is none.
   *
   * @return {string|boolean}
   */
  getSEOContent() {
    const { seoKey, seo } = this.props

    if ( Object.prototype.hasOwnProperty.call( seo, seoKey )) {
      return seo[seoKey]
    } else {
      return false
    }

  }

  /**
   * Render method.
   */
  render() {
    const { topContent, translations, didFetch } = this.props
    const seoField = this.getSEOContent()

    if ( seoField === false || didFetch ) return null

    const seoHTML = topContent ? seoField.content_top : seoField.content_bottom

    return (
      <Outer className={`${this.state.expanded ? 'expanded' : ''}`}>
        <Container dangerouslySetInnerHTML={{ __html: seoHTML }} />
        <Expand onClick={this.toggleExpanded} tabIndex="0">
          {translate( translations, 'Read more' )}
        </Expand>
      </Outer>
    )
  }
}

SEOContent.propTypes = {
  seo: PropTypes.object.isRequired,
  seoKey: PropTypes.string.isRequired,
  translations: PropTypes.object.isRequired,
  topContent: PropTypes.bool,
  didFetch: PropTypes.bool
}

/**
 * Map the redux state to component props.
 *
 * @param {object} state
 * @return {object}
 */
const mapStateToProps = ( state ) => ({
  seo: state.seo,
  seoKey: state.queryParams.full,
  translations: state.translations,
  didFetch: state.search.didFetch,
})

export default connect(
  mapStateToProps
)( SEOContent )
